import { fetchDataWithFallback } from "@/lib/indexedDb/product";
import { searchBySingleIndex } from "@/services/algolia";
import { ALGOLIA_INDEXES } from "@/services/algolia/config";
import { resetCartProductList } from "@/utils/redux/cartProduct";
import { resetOffersList } from "@/utils/redux/favOffers";
import { resetFavouriteProductList } from "@/utils/redux/favouriteProduct";
import { resetLoadedOffers } from "@/utils/redux/fetchOffers";
import { resetManageList } from "@/utils/redux/manageList";
import { resetShoppingList } from "@/utils/redux/shoppingList";
import {
  ArticleWithUserData,
  ShoppedInterface,
  ShoppingListItem,
  ShoppingListProduct,
} from "@/utils/types/manageList";
import { Product } from "@/utils/types/product";
import jsPDF from "jspdf";
import { getAlcoholStoreFilter } from "./productsFilterHelper";
import { getUnixTime } from "date-fns";
import { FLYER_PROMOTIONS_SOURCE, PromotionKeys, TPromotionKeys } from "@/utils/constant";

export const sortList = async (
  updatedArticles: Record<string, any>,
  listSort: string,
  shoppingProducts: Record<string, any>,
) => {
  const filteredproducts = updatedArticles ?? [];

  let transformedData = {};
  switch (listSort) {
    case "byDepartment": {
      const sortByDepartment = filteredproducts?.reduce(
        (acc: Record<string, any>, product: ArticleWithUserData) => {
          const lvl0: string =
            product?.hierarchicalCategories?.lvl0?.[0] ?? "No Category Items";
          if (!acc[lvl0]) {
            acc[lvl0] = [];
          }
          acc[lvl0].push({
            ...product,
          });
          return acc;
        },
        {}  as Record<string, ArticleWithUserData[]>
      );
      const updatedAtMap: Record<string, string> = {};
      shoppingProducts.forEach((item: ShoppingListItem) => {
        if (item.item_id && item.createdAt) {
          updatedAtMap[item.item_id] = item.createdAt;
        }
      });

      for (const department in sortByDepartment) {
        sortByDepartment[department].sort((a: Product, b: Product) => {
          const timeA = updatedAtMap[a?.objectID] ? new Date(updatedAtMap[a?.objectID]).getTime() : 0;
          const timeB = updatedAtMap[b?.objectID] ? new Date(updatedAtMap[b?.objectID]).getTime() : 0;
          return timeB - timeA;
        });
      }
      transformedData = sortByDepartment;
    
      break;
    }
    case "priceHightoLow": {
      const sortPriceHighToLow = filteredproducts?.sort(
        (a: { price: number }, b: { price: number }) => b.price - a.price
      );
      transformedData = {
        Price: [...sortPriceHighToLow],
      };
      break;
    }

    case "priceLowToHigh": {
      const sortPriceLowToHigh = filteredproducts?.sort(
        (a: { price: number }, b: { price: number }) => a.price - b.price
      );
      transformedData = {
        Price: [...sortPriceLowToHigh],
      };
      break;
    }

    case "alphabatical": {
      const sortAlphabatetical = filteredproducts.sort(
        (a: { name: string }, b: { name: any }) => a.name.localeCompare(b.name)
      );
      transformedData = {
        alphabatetical: [...sortAlphabatetical],
      };
      break;
    }

    default:
      break;
  }
  console.log("transformedData", transformedData);
  return transformedData;
};

export const getArticleIds = (products: Record<string, any>) => {
  const articleIds = products
    ?.filter((item: ShoppingListItem) => item?.itemId !== "")
    .map((item: ShoppingListItem) => item);

  const itemsQuery = articleIds
    .filter((id: object) => id)
    .map((id: ShoppingListItem) => `articleId:${id.item_id}`)
    .join(" OR ");

  return itemsQuery;
};

// export const fetchAlgoliaProducts = async (
//   products: Record<string, any>,
//   storeID: string = "",
//   isNoAlcoholStore: boolean = false
// ) => {
//   const articleIds = products
//     ?.filter((item: ShoppingListItem) => item?.item_id !== "")
//     .map((item: ShoppingListItem) => item);

//   const itemsQuery = articleIds
//     ?.filter((id: object) => id)
//     .map((id: ShoppingListItem) => `articleNumber:${id.item_id}`)
//     .join(" OR ");

//   const filters = isNoAlcoholStore
//     ? `(${itemsQuery}) AND storeId:${storeID} AND allergens.alcohol:false  AND isMassOffers:false AND isVisible:true`
//     : `(${itemsQuery}) AND storeId:${storeID}  AND isMassOffers:false AND isVisible:true`;

//   // const filters =  ` (${itemsQuery}) AND storeId:${storeID} AND allergens.alcohol:false AND isMassOffers:false `;

//   if (itemsQuery) {
//     const productData = await searchBySingleIndex({
//       indexName: ALGOLIA_INDEXES.PRODUCTS.PRIMARY_INDEX,
//       searchParams: {
//         filters: filters,
//         hitsPerPage: articleIds?.length,
//       },
//     });

//     const products = productData?.hits || [];
//     return products;
//   }
// };

export const fetchAlgoliaProduct = async (
  products: Record<string, any>,
  storeID: string = "",
  storeRegion: string = ""
) => {
  try {
    const articleIds = products
      ?.filter((item: any) => item?.item_id !== "") // Changed ShoppingListItem to any
      .map((item: any) => String(item?.item_id?.split('_').slice(0, 2).join('_')));

    if (!articleIds || articleIds.length === 0) {
      return [];
    }
    // 1. Try to get from local DB
    return await fetchDataWithFallback(articleIds);
  } catch (error) {
    console.error("Error in fetchAlgoliaProduct:", error);
    return [];
  }
};

export const clearShoppingSlice = () => (dispatch: any) => {
  dispatch(resetShoppingList());
  dispatch(resetManageList());
  dispatch(resetFavouriteProductList());
  dispatch(resetCartProductList());
  dispatch(resetOffersList());
  dispatch(resetLoadedOffers());
};

// const fetchImage = async () => {
//   const response = await fetch("/assets/products/merchant_print_logo.png"); // Image in public folder
//   const blob = await response.blob();

//   return new Promise((resolve) => {
//     const reader = new FileReader();
//     reader.onloadend = () => resolve(reader.result);
//     reader.readAsDataURL(blob);
//   });
// };
const fetchSvgAsPng = async (): Promise<string> => {
  const response = await fetch("/assets/products/print-banner-logo.svg");
  const svgText = await response.text();

  const svgBlob = new Blob([svgText], { type: "image/svg+xml" });
  const url = URL.createObjectURL(svgBlob);

  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = url;

  return new Promise((resolve, reject) => {
    img.onload = () => {
      const scale = 8;
      const width = img.width || 300;
      const height = img.height || 100;

      const canvas = document.createElement("canvas");
      canvas.width = width * scale;
      canvas.height = height * scale;

      const ctx = canvas.getContext("2d");
      ctx?.scale(scale, scale);

      ctx?.drawImage(img, 0, 0);

      const pngDataUrl = canvas.toDataURL("image/png");
      resolve(pngDataUrl);
    };
    img.onerror = () => reject("SVG failed to load");
  });
};


export const printPDF = async (contentRef: any, type: string) => {
  try {
    const element = contentRef;
    if (!element) return;

    const doc = new jsPDF("p", "pt", "letter");

    const Base64: any = await fetchSvgAsPng();
    const logo = Base64.split(",")[1];
    const logoWidth = 120;
    const logoHeight = 37;
    const logoX = 40;
    const logoY = 30;
    // setTimeout(async() => {
    return new Promise((resolve, reject) => {
      doc.html(element, {
        margin: [100, 12, 50, 12],
        autoPaging: "text",
        html2canvas: {
          removeContainer: true,
          letterRendering: true,
          logging: false,
          scale: 1,
        },
        callback: function (doc) {
          const totalPages = (doc as any).internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            if (logo) {
              doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);
            } else {
              console.error("Logo is not set");
            }
          }
          if (type === "share") {
            const result = doc.output("datauristring");
            resolve(result);
          } else {
            window.open(URL.createObjectURL(doc.output("blob")));
          }
        },
      });
    });
  } catch (err) {
    console.log("error", err);
  }
};

export const formatDate = (date: string) => {
  const parsedDate = new Date(date);
  const formattedDate = parsedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return formattedDate;
};

export const listSlug = (name: string) => {
  if (typeof name !== "string") {
    return "";
  }
  return name.replaceAll(" ", "-").toLowerCase();
};

export const getBase64FromUrl = async (url: string): Promise<string | null> => {
  try {
    const response = await fetch(url);
    const buffer = await response.arrayBuffer();
    return `data:image/png;base64,${Buffer.from(buffer).toString("base64")}`;
  } catch (error) {
    console.error("Failed to load image:", error);
    return null;
  }
};

// export const addLogo = (doc: jsPDF, logo: string | null, yPosition: number) => {
//   if (logo) {
//     doc.addImage(logo, "PNG", 10, yPosition, 50, 15); // (x: 10, y: yPosition, width: 50, height: 15)
//     yPosition += 32;
//   }
//   return yPosition;
// };

export const capitalizeName = (str: string) => {
  return str?.toLowerCase().split(' ').map(word => 
    word?.charAt(0).toUpperCase() + word?.slice(1)
  ).join(' ');
}

export const addTitle = (doc: jsPDF, title: string, yPosition: number) => {
  if (title) {
    const truncatedTitle = title.length > 35 ? `${(title.substring(0, 35))}...` : (title);
    yPosition += 40;
    doc.setFont("helvetica", "bold").setFontSize(24).text(truncatedTitle, 10, yPosition);
  }
  return yPosition + 7;
};
 

export const decodeHtmlEntities = (text: string) => {
  return text.replace(/&/g, "&");
};

export const generateItemContent = (
  doc: jsPDF,
  item: any,
  type: string,
  yPosition: number,
  pageWidth: number,
  scenePlusIcon?: string | null,
  shoppingList?: any,
  logo?: any,
  searchDropdown?: any,
  storeId?:  any
) => {
  const pageHeight = doc.internal.pageSize.height;
  const bottomMargin = 20; // Ensure a bottom margin
  const itemHeight = 15;
  // Check if new item will fit, else add a page
  if (yPosition + itemHeight >= pageHeight - bottomMargin) {
    doc.addPage();
    yPosition = 40; // Reset y-position for the new page
    // yPosition = addLogo(doc, logo, yPosition);
  }
  const prefilledItem = shoppingList?.products?.find(
    (product: ShoppingListItem) => product?.item_id == item?.objectID
  );


  // Extract promotion points before rendering
  // const promotionPoints = getPromotionPoints(item?.promotions);
  const promotionSalePrice = getPromotionPice([item]);
  
  const key = promotionSalePrice?.[0]?.offerType ? PromotionKeys[promotionSalePrice[0].offerType as TPromotionKeys] : undefined;
  const dropdownValue = key && searchDropdown?.dropdown ? searchDropdown.dropdown[key as keyof typeof searchDropdown.dropdown] : undefined;
  
  if ((promotionSalePrice?.[0]?.rewardType == 7 || promotionSalePrice?.[0]?.rewardType == 2 || promotionSalePrice?.[0]?.offerType == 9) && promotionSalePrice?.[0]?.offerType != 3 && promotionSalePrice?.[0]?.offerType != 4 && promotionSalePrice?.[0]?.offerType != 6 && promotionSalePrice?.[0]?.offerType !=10 &&  promotionSalePrice?.[0]?.memberPrice  && ( !searchDropdown?.dropdown?.hidePromotions || !searchDropdown?.dropdown?.hideallpromotions )) {
    if(showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId) ) {
        // Create points property if it doesn't exist
        item.points = promotionSalePrice?.[0]?.memberPrice?.toString();
        item.pointsText = `SCENE+ ${Number(promotionSalePrice?.[0]?.memberPrice)} Points`;
      
    }
  }

  // Add line between platform items
  if (type === "product") {
    yPosition += 4;
    const lineY = yPosition + 16;
    doc.setLineWidth(0.3);
    doc.setDrawColor(200);
    doc.line(10, lineY, 200, lineY);
    doc.setDrawColor(0);
  }

  doc.setFontSize(12);
  doc.setLineWidth(0.7);
  doc.roundedRect(
    10,
    yPosition,
    6,
    6,
    1,
    1,
    prefilledItem?.is_shopped || item?.is_shopped ? "DF" : "S"
  );
  if (prefilledItem?.is_shopped == 1 || item?.is_shopped) {
    doc.setDrawColor(255, 255, 255);
    doc.line(11.5, yPosition + 3, 12.5, yPosition + 4.5);
    doc.line(12, yPosition + 4.5, 15, yPosition + 1.5);
    doc.setDrawColor(0);
  }
  let productName;
  if (type == "custom") {
    productName = item?.meta ? JSON.parse(item?.meta) : "";
    productName = productName?.name ? `Qty: ${item.quantity}x - ${productName?.name?.length > 40 ? `${productName?.name?.slice(0, 40)}...` : productName?.name }`  : "";
    // productName = `Qty: ${item.quantity}X`
  } else {
    productName =
      item?.name?.length > 40 ? `${item?.name?.slice(0, 40)}...` : item?.name;
  }
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(12); // Smaller font size for barnd
  // doc.text(
  //   (item?.brand ?? "").charAt(0).toUpperCase() + (item?.brand ?? "").slice(1),
  //   20,
  //   yPosition + (item?.brand ? 4.5 : 0)
  // );

 // For brand text
 if (type !== "custom") {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12); // Smaller font size for brand
  const brandText = item?.brand ? 
    (item.brand.charAt(0).toUpperCase() + item.brand.slice(1)).replace(/\n/g, "") : 
    "--";
  doc.text(brandText, 20, yPosition + 4.5); 
}


  // doc.setFont("helvetica", "normal");
  // doc.setFontSize(14); // Smaller font size for productName
  // doc.text(
  //   productName
  //     ? productName.charAt(0).toUpperCase() + productName.slice(1).toLowerCase()
  //     : "--",
  //   20,
  //   yPosition + (item?.brand ? 12 : 5)
  // );

  // For product name - increase y-position to ensure no overlap
  if (type !== "custom") {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14); // Size for product name
    const formattedProductName = productName ? 
      productName.charAt(0).toUpperCase() + productName.slice(1).toLowerCase() : 
      "--";
    doc.text(formattedProductName, 20, yPosition + 11); // Increased from 12 to 14}
  } else {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14); // Size for product name
    const formattedProductName = productName ? 
      productName.charAt(0).toUpperCase() + productName.slice(1).toLowerCase() : 
      "--";
    doc.text(formattedProductName, 20, yPosition + 5);
  }
  // doc.text(productName ? productName : '--', 20, yPosition + (item?.brand ? 12 : 5));
  const drawScenePlusIcon = (
    doc: jsPDF,
    x: number,
    y: number,
    dotRadius: number = 0.5,
    spacing: number = 1.5
  ): void => {
    // Top center dot
    doc.circle(x, y - spacing, dotRadius, 'F');
  
    // Middle three dots
    doc.circle(x - spacing, y, dotRadius, 'F'); // Left
    doc.circle(x, y, dotRadius, 'F');           // Center
    doc.circle(x + spacing, y, dotRadius, 'F'); // Right
  
    // Bottom center dot
    doc.circle(x, y + spacing, dotRadius, 'F');
  };
  if(promotionSalePrice && promotionSalePrice.length > 0 && promotionSalePrice?.[0]?.memberType.includes("Y") && item?.pointsText && (showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId )) ) {
    console.log(promotionSalePrice?.[0]?.offerIdentifier, "ddddd")
          doc.setFont("helvetica", "normal");
          doc.setFontSize(12);
          const textWidth: number =
            (doc.getStringUnitWidth(item.pointsText) * doc.getFontSize()) /
            doc.internal.scaleFactor;
          const iconX: number = pageWidth - 10 - textWidth - 4;
          drawScenePlusIcon(doc, iconX, yPosition + 1.5);
          doc.setFont("helvetica", "normal");
          doc.text(item.pointsText, pageWidth - 10, yPosition + 3, {
            align: "right",
    });
  }

  if (prefilledItem?.quantity && type == "product") {
    let salePrice = 0;
    if(promotionSalePrice?.[0]?.memberType?.includes('Y')){
      if(checkOfferIdentifier(promotionSalePrice?.[0]?.offerIdentifier)){
          if(promotionSalePrice?.[0]?.newMemberType == "N"){
            salePrice = promotionSalePrice?.[0]?.salePrice;
          }else if( promotionSalePrice?.[0]?.newMemberType == "Y") {
            salePrice = parseFloat(promotionSalePrice?.[0]?.newMemberPrice) ;
          }
         else if(promotionSalePrice?.[0]?.salePrice) {
            salePrice = promotionSalePrice?.[0]?.salePrice;
          }else {
            salePrice = promotionSalePrice?.[0]?.memberPrice;
          }
        }else {
          salePrice = promotionSalePrice?.[0]?.memberPrice
        }
    }else {
      salePrice = promotionSalePrice?.[0]?.salePrice;
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(13);
    doc.text(
      `Qty: ${prefilledItem.quantity}x`,
     
      // {(promotionSalePrice?.[0]?.offerIdentifier ===
      //   "No Min Condition" ||
      //   promotionSalePrice?.[0]?.offerIdentifier ===
      //   "No Min Condition with Multi Promo" ||
      //   promotionSalePrice?.[0]?.offerIdentifier ===
      //   "Multi Reward"||
      //   promotionSalePrice?.[0]?.offerIdentifier ===
      //   "multi promo type 1"  ||
      //   promotionSalePrice?.[0]?.offerIdentifier ===
      //   "Multi promo only VKAO" ||
      //   promotionSalePrice?.[0]?.offerIdentifier ===
      //   "3 Promotions") &&
      (promotionSalePrice && promotionSalePrice.length > 0 && checkOfferIdentifier(promotionSalePrice?.[0]?.offerIdentifier) &&
        salePrice <
        promotionSalePrice?.[0]?.price && item?.price && (showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId) ))  ? pageWidth -(item?.uom === "KG" ? 70 :  58) :  pageWidth - (item?.uom === "KG" ? 50 : 42),
      yPosition + ((promotionSalePrice && promotionSalePrice.length > 0 && promotionSalePrice?.[0]?.memberType.includes("Y")
       && item?.pointsText && ( showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId))) ? 12 : 9),
    );
  }

  if (item?.price) {
    let salePrice = 0;
    if(promotionSalePrice?.[0]?.memberType?.includes('Y')){
      if(checkOfferIdentifier(promotionSalePrice?.[0]?.offerIdentifier)){
          if(promotionSalePrice?.[0]?.newMemberType == "N"){
            salePrice = promotionSalePrice?.[0]?.salePrice;
          }else if( promotionSalePrice?.[0]?.newMemberType == "Y") {
            salePrice = parseFloat(promotionSalePrice?.[0]?.newMemberPrice) ;
          }
         else if(promotionSalePrice?.[0]?.salePrice) {
            salePrice = promotionSalePrice?.[0]?.salePrice;
          }else {
            salePrice = promotionSalePrice?.[0]?.memberPrice;
          }
        }else {
          salePrice = promotionSalePrice?.[0]?.memberPrice
        }
    }else {
      salePrice = promotionSalePrice?.[0]?.salePrice;
    }
    doc.setFont("helvetica", "bold");
    if(promotionSalePrice && promotionSalePrice.length > 0 && checkOfferIdentifier(promotionSalePrice?.[0]?.offerIdentifier) &&
      salePrice <
      promotionSalePrice?.[0]?.price && (showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId) )){
      doc.setTextColor(150);

    }else {
      doc.setTextColor(0);
    }

    doc.text(
      `$${item?.price?.toFixed(2)}${item?.uom === "KG"
                        ? "/kg"
                        : ""}`,
      pageWidth - 10,
      yPosition + ((promotionSalePrice && promotionSalePrice.length > 0 && promotionSalePrice?.[0]?.memberType.includes("Y") && item?.pointsText && (showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId))) ? 12 : 9),
      {
        align: "right",
      }
    );
    doc.setTextColor(0);

  }

  if (promotionSalePrice && promotionSalePrice.length > 0 && (showPromotionsAlgolia(item?.hidePromotions , dropdownValue as string[] ?? [], storeId))) {
    let salePrice = 0;
    if(promotionSalePrice?.[0]?.memberType?.includes('Y')){
      if(checkOfferIdentifier(promotionSalePrice?.[0]?.offerIdentifier)){
          if(promotionSalePrice?.[0]?.newMemberType == "N"){
            salePrice = promotionSalePrice?.[0]?.salePrice;
          }else if( promotionSalePrice?.[0]?.newMemberType == "Y") {
            salePrice = parseFloat(promotionSalePrice?.[0]?.newMemberPrice) ;
          }
         else if(promotionSalePrice?.[0]?.salePrice) {
            salePrice = promotionSalePrice?.[0]?.salePrice;
          }else {
            salePrice = promotionSalePrice?.[0]?.memberPrice;
          }
        }else {
          salePrice = promotionSalePrice?.[0]?.memberPrice
        }
    }else {
      salePrice = promotionSalePrice?.[0]?.salePrice;
    }

    if((checkOfferIdentifier(promotionSalePrice?.[0]?.offerIdentifier)) &&
      salePrice <
      promotionSalePrice?.[0]?.price){
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0);
    const originalPriceText = `$${salePrice?.toFixed(2)}${item?.uom === "KG"
                        ? "/kg"
                        : ""}`;
    const textWidth = doc.getTextWidth(originalPriceText);
    const originalPriceX = pageWidth - (salePrice ? (item?.uom === "KG" ? 32 : 25) : 10) - textWidth;
    const textY = yPosition + ((promotionSalePrice && promotionSalePrice.length > 0 && promotionSalePrice?.[0]?.memberType.includes("Y") && item?.pointsText) ? 12 : 9);

    doc.text(originalPriceText, originalPriceX, textY);
    doc.setDrawColor(150);
    doc.setLineWidth(0.5);
    // doc.line(originalPriceX, textY - 2, originalPriceX + textWidth, textY - 2);

    doc.setTextColor(0);
    doc.setDrawColor(0);
      }
  }

  // for custum list item gap
  return yPosition + (type === "custom" ? 12 : 15);
};

// Helper function to extract promotion points
function getPromotionPoints(promotions: any): number {
  type Value1Value20 = {
    value_1?: string;
  };
  type PromotionReward = {
    value1Value20?: Value1Value20[];
  };
  type Promotion = {
    promotionReward?: PromotionReward[];
  };
  if (!promotions || !Array.isArray(promotions)) return 0;
  let totalPoints = 0;
  (promotions as Promotion[]).forEach((promo) => {
    console.log("promo<>>>", promotions)
    promo.promotionReward?.forEach((reward) => {
      reward.value1Value20?.forEach((valueObj) => {
        if (valueObj?.value_1) {
          totalPoints += parseFloat(valueObj.value_1);
        }
      });
    });
  });
  return totalPoints;
}

export function getPromotionPice(data: any) {
  try {
    const currentDate = getUnixTime(new Date());
    const finalData: any = [];
    let activePromotionLength: any;

    if (data.length > 0) {
      for (const promotionData of data) {
        console.log(promotionData.objectID, "testdata");

        let activePromotions = promotionData?.promotions?.filter((item: any) =>
          item.startDate <= currentDate &&
          item.endDate > currentDate &&
          item.promotionComplianceFlag === true
        );
        activePromotionLength = activePromotions?.length;
        // if (activePromotionLength > 0) {
        //   const flyerPromo = activePromotions.find((item: any) => item.source === FLYER_PROMOTIONS_SOURCE);
        //   if (flyerPromo) activePromotions = [flyerPromo];
        //   activePromotionLength = activePromotions.length;
        // }

        if (activePromotionLength > 0) {
          const activePromotion = activePromotions?.[0] ?? {};
          const promotionReward = activePromotion.promotionReward?.[0] ?? {};
          const promotionCondition =
            activePromotion.promotionCondition?.[0] ?? {};
          const rewardLength = activePromotion.promotionReward?.length;
          const promotionLength = activePromotion.promotionCondition?.length;
          // Destructure the fields
          let {
            rewardType,
            membershipLevelText: memberType,
            value1Value20: rewardValueArray = [],
            rewardShortDesc: rewardDescription,
            rewardShortDescFrench: rewardDescriptionFr,
            rewardTrigger,
            applyTo: rewardApplyTo,
          } = promotionReward;

          let {
            value1Value20: promotionValueArray = [],
            conditionType,
            breakpointFlag,
          } = promotionCondition;

          let rewardValue = rewardValueArray?.[0]?.value_1;
          let promotionValue = promotionValueArray?.[0]?.value_1;

          // Promotion level info
          let {
            promotionDescription,
            promotionDescriptionFr,
            startDate: promotionStartDate,
            endDate: promotionEndDate,
            source: promotionSource,
          } = activePromotion;

          // Other values
          let salePrice: number;
          let memberPrice: number;
          let offerType: number;
          let newMemberType: string
          const rewardArticalID: string[] = [];
          let promotionFullDesc: any;

          // Final promoData object
          const promoData = {
            // Product data
            brand: promotionData?.brand,
            uom: promotionData?.uom,
            categories: promotionData?.categories,
            description: promotionData?.description,
            images: promotionData?.images,
            isVisible: promotionData?.isVisible,
            name: promotionData?.name,
            objectID: promotionData?.objectID,
            otherInformation: promotionData?.otherInformation,
            price: promotionData?.price,
            salePrice: promotionData?.salePrice,
            memberPrice: promotionData?.memberPrice,
            newMemberPrice: promotionData?.newMemberPrice,
            storeId: promotionData?.storeId,
            weight: promotionData?.weight,
            priceQuantity: promotionData?.priceQuantity,
            storageInstructions: promotionData?.storageInstructions,
            isOnSale: promotionData?.isOnSale,
            isMassOffers: promotionData?.isMassOffers,
            isFlyerProduct: promotionData?.isFlyerProduct,
            isActivePromotion: promotionData?.isActivePromotion,
            hierarchicalCategories: promotionData?.hierarchicalCategories,
            articleNumber: promotionData?.articleNumber,
            rewardArticalID,

            // Promo details
            conditionType,
            promotionDescription,
            promotionFullDesc,
            promotionDescriptionFr,
            rewardDescription,
            rewardDescriptionFr,
            rewardValue,
            rewardType,
            memberType,
            rewardTrigger,
            rewardApplyTo,
            promotionValue,
            promotionStartDate,
            promotionEndDate,
            promotionSource,
            breakpointFlag,
            cardType: memberType?.includes("Y") ? "Member" : "Scene+",
          };

          // calculation of price -- member and sale price
          const priceCalculation = (filteredPromo?: any) => {
            const isMember = filteredPromo ? filteredPromo?.promotionReward?.[0]?.membershipLevelText.includes("Y") : memberType?.includes("Y");
            const source = "CMA";
            const basePrice = parseFloat(promotionData?.price);
            const RV = filteredPromo ? parseFloat(filteredPromo?.promotionReward?.[0]?.value1Value20?.[0]?.value_1) : parseFloat(rewardValue);
            const wieght = parseFloat(promotionData?.weight);
            let calculatedPrice = 0;
            switch (rewardType) {
              case 1:
                calculatedPrice = promotionSource == source ? RV / 100 : RV;
                break;
              case 2:
                calculatedPrice =
                  promotionSource == source
                    ? (basePrice * RV) / 100
                    : basePrice * RV;
                break;
              case 3:
                calculatedPrice =
                  promotionSource == source
                    ? (RV / 100) * wieght
                    : RV * wieght;
                break;
              case 4:
              case 5:
                calculatedPrice = promotionSource == source ? RV / 100 : RV;
                return isMember
                  ? { memberPrice: calculatedPrice, salePrice }
                  : { salePrice: calculatedPrice, memberPrice: promoData?.memberPrice };
              // case 5:
              //   calculatedPrice =
              //     (RV * 1000) *
              //     parseFloat(promotionData?.weight);
              //   break;
              case 6:
                return isMember
                  ? { memberPrice: basePrice, salePrice }
                  : { salePrice: basePrice, memberPrice: promoData?.memberPrice };
              case 7:
                return { memberPrice: parseInt(rewardValue) };
              default:
                return {};
            }
            return isMember
              ? { memberPrice: basePrice - calculatedPrice, salePrice }
              : { salePrice: basePrice - calculatedPrice, memberPrice: promoData?.memberPrice };
          };
          // add promotion function
          const addPromotionData = (
            identifier: string,
            priceData: any,
            offerType: number,
            promotionDescription?: any
          ) => {
            promoData.memberType = promoData.memberType == '' ? "NNNNNNNNNNNNNNNN": promoData.memberType
            finalData.push({
              ...promoData, newMemberType,
              offerIdentifier: identifier,
              ...priceData,
              offerType,
              ...promotionDescription,
            });
            return finalData;
          };
          const hasNoMinCondition = ((conditionType == undefined || conditionType == null || conditionType == "") &&
            (rewardTrigger == null || rewardTrigger == 1 || rewardTrigger == "")) ||
            (conditionType == 1 && promotionValue == 1 && (rewardTrigger == null || rewardTrigger == 1 || rewardTrigger == ""));
          if (activePromotionLength == 1) {
            // checking promotion ITEMS and rewards ITEMS are equal
            let promotionItems =
              activePromotions[0].promotionCondition?.[0]?.items;
            let rewardItems = activePromotions[0]?.promotionReward?.[0]?.items;
            //getting artical id from promotion reward
            rewardItems.forEach((elem: any) => {
              rewardArticalID.push(elem.articleNumber);
            });
            //single reward
            const conditionLength = activePromotions[0]?.promotionCondition.length;
            if (conditionLength == 1) {
              if (rewardLength == 1) {
                // no min spend condition
                console.log(">>>>> no min  condition");
                if (hasNoMinCondition) {
                  console.log("No Min Condition --", promotionData?.objectID, "reward_type--", rewardType);
                  const priceData = priceCalculation();
                  addPromotionData("No Min Condition", priceData, offerType = 1);
                } else {
                  // min spend condition
                  console.log(">>>>> min spend condition");
                  const promotionItemsCheck = promotionItems?.some(
                    (item: any) => item?.articleNumber == promoData?.articleNumber
                  );
                  const rewardItemsCheck = rewardItems?.some(
                    (item: any) => item?.articleNumber == promoData?.articleNumber
                  );
                  if (promotionItems == 0 || (promotionItemsCheck && rewardItemsCheck)) {
                    if (conditionType == 1 ||
                      ((conditionType == null || conditionType == "" || conditionType == undefined) && rewardTrigger > 1)) {
                      if (rewardTrigger == rewardApplyTo && rewardTrigger > 1) {
                        // success condition
                        console.log("YES Min Condition QTY 1--", promotionData?.objectID, "reward_type--", rewardType);
                        const priceData = priceCalculation();
                        addPromotionData("YES Min Condition QTY 1", priceData, offerType = 2, promotionDescription);
                      } else {
                        // no condition
                        console.log("No Min Condition QTY 1--", promotionData?.objectID, "reward_type--", rewardType);
                        const priceData = priceCalculation();
                        addPromotionData("No Min Condition QTY 1", priceData, offerType = 3, promotionDescription);
                      }
                      // }
                    } else if (conditionType == 2) {
                      console.log("YES Min Condition QTY 2--", promotionData?.objectID, "reward_type--", rewardType);
                      const priceData = priceCalculation();
                      addPromotionData("YES Min Condition QTY 2", priceData, offerType = 4, promotionDescription);
                    } else if (conditionType == 3) {
                      console.log("YES Min Condition QTY 3--", promotionData?.objectID, "reward_type", rewardType);
                      const priceData = priceCalculation();
                      addPromotionData("YES Min Condition QTY 3", priceData, offerType = 5, promotionDescription);
                    }
                  }
                }
              } else if (rewardLength == 2) {
                if (promotionSource !== "CMA") {
                  for (const promoReward of activePromotions[0].promotionReward) {
                    if (promoReward?.items?.length > 0) {
                      rewardType = promoReward.rewardType;
                      memberType = promoReward?.membershipLevelText;
                      rewardValue = promoReward?.value1Value20?.[0]?.value_1;
                      promoData.rewardType = rewardType;
                      promoData.memberType = memberType;
                      promoData.rewardValue = rewardValue;
                      if (hasNoMinCondition) {
                        console.log("min from reward");
                        const priceData = priceCalculation();
                        // addPromotionData("No Min Condition", priceData);
                      }
                    }
                  }
                } else {
                  // multiple rewards
                  let priceData: any = {};
                  let res: any;
                  let hasRewardType7 = false;
                  let newRewardType;
                  let newRewardValue;
                  for (const promoReward of activePromotions[0].promotionReward) {
                    if (promoReward.rewardType == 7) {
                      hasRewardType7 = true;
                      rewardType = promoReward.rewardType;
                      memberType = promoReward?.membershipLevelText;
                      rewardValue = promoReward?.value1Value20?.[0]?.value_1;
                      promoData.rewardType = rewardType;
                      //promoData.memberType = memberType;
                      promoData.rewardValue = rewardValue;
                      res = priceCalculation();
                      priceData.memberPrice = res?.memberPrice;
                    } else if (promoReward.rewardType !== 7) {
                      rewardType = promoReward.rewardType;
                      newRewardType = promoReward.rewardType
                      memberType = "NNNNNNNNNNN";
                      rewardValue = promoReward?.value1Value20?.[0]?.value_1;
                      newRewardValue = promoReward?.value1Value20?.[0]?.value_1
                      promoData.rewardType = rewardType;
                      promoData.memberType = memberType;
                      promoData.rewardValue = rewardValue;
                      res = priceCalculation();
                      salePrice = res?.salePrice
                      priceData.salePrice = salePrice;
                    }
                  }
                  if (hasRewardType7) {
                    promoData.memberType = 'YYYYYYYYYYYYYYYY'
                    promoData.rewardType = newRewardType;
                    promoData.rewardValue = newRewardValue;
                    console.log("Multi Reward--", promotionData?.objectID, "reward_type--", rewardType);
                     addPromotionData("Multi Reward", priceData, offerType = 7);
                  }
                }
              }
            }
          } else if (activePromotionLength == 2) {
            let priceData: any = {};
            let res: any;
            const hasRewardType7 = activePromotions?.find((item: any) => (item?.promotionReward.find((pr: any) => pr?.rewardType == '7')));
            const noRewardType7 = activePromotions?.find((item: any) => (item?.promotionReward.find((pr: any) => (pr?.rewardType == '1' || pr?.rewardType == '2' || pr?.rewardType == '4'))));
            if (hasRewardType7) {
              if (noRewardType7) {
                conditionType = noRewardType7?.promotionCondition?.[0]?.conditionType;
                promotionValue = noRewardType7?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
                rewardTrigger = noRewardType7?.promotionReward?.[0]?.rewardTrigger;

                promoData.conditionType = conditionType
                promoData.promotionValue = promotionValue
                promoData.rewardTrigger = rewardTrigger;
                const hasNoMinCondition = ((promoData.conditionType == undefined || promoData.conditionType == null || promoData.conditionType == "") &&
                  (rewardTrigger == null || promoData.rewardTrigger == 1 || promoData.rewardTrigger == "")) ||
                  (promoData.conditionType == 1 && promoData.promotionValue == 1 && (promoData.rewardTrigger == null || promoData.rewardTrigger == 1 || rewardTrigger == ""))
                if (hasNoMinCondition) {
                  conditionType = hasRewardType7?.promotionCondition?.[0]?.conditionType;
                  promotionValue = hasRewardType7?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
                  rewardTrigger = hasRewardType7?.promotionReward?.[0]?.rewardTrigger;
                  promoData.conditionType = conditionType
                  promoData.promotionValue = promotionValue
                  promoData.rewardTrigger = rewardTrigger;
                  const hasNoMinCondition = ((promoData.conditionType == undefined || promoData.conditionType == null || promoData.conditionType == "") &&
                    (rewardTrigger == null || promoData.rewardTrigger == 1 || promoData.rewardTrigger == "")) ||
                    (promoData.conditionType == 1 && promoData.promotionValue == 1 && (promoData.rewardTrigger == null || promoData.rewardTrigger == 1 || rewardTrigger == ""))
                  if (hasNoMinCondition) {
                    let res;
                    if (noRewardType7?.promotionReward?.[0]?.membershipLevelText?.includes("N") || noRewardType7?.promotionReward?.[0]?.membershipLevelText == '') {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText ?? 'NNNNNNNN';
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source;
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      newMemberType = 'N'
                      res = priceCalculation();
                      priceData.salePrice = res?.salePrice;
                      // priceData.newMemberPrice = (res?.memberPrice?.toFixed(2));
                    } else {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText;
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      newMemberType = 'Y'
                      res = priceCalculation();
                      priceData.newMemberPrice = (res?.memberPrice)?.toFixed(2);
                    };
                    memberType = 'YYYYYYYYYYYYYYYY'
                    promoData.memberType = memberType
                    priceData.memberPrice = hasRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                    memberPrice = priceData.memberPrice
                    promoData.memberPrice = memberPrice

                    console.log('multi promo type 1', promotionData?.objectID, "reward_type", rewardType)
                    addPromotionData('multi promo type 1', priceData, offerType = 9)
                  } else {
                    let res;
                    if (noRewardType7?.promotionReward?.[0]?.membershipLevelText?.includes("N") || noRewardType7?.promotionReward?.[0]?.membershipLevelText == '') {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText == '' ? 'NNNNNNNNNNNNNNNN' : noRewardType7?.promotionReward?.[0]?.membershipLevelText;                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source;
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      newMemberType = 'N'
                      res = priceCalculation();
                      priceData.salePrice = res?.salePrice;
                      //priceData.newMemberPrice = (res?.memberPrice?.toFixed(2));
                    } else {
                      memberType = noRewardType7?.promotionReward?.[0]?.membershipLevelText;
                      rewardType = noRewardType7?.promotionReward?.[0]?.rewardType;
                      rewardValue = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                      promotionSource = noRewardType7?.source
                      promoData.memberType = memberType
                      promoData.rewardType = rewardType
                      promoData.rewardValue = rewardValue
                      promoData.promotionSource = promotionSource
                      //newMemberType = 'Y'
                      res = priceCalculation();
                      //priceData.newMemberPrice = (res?.memberPrice)?.toFixed(2);
                    };
                    //memberType = 'YYYYYYYYYYYYYYYY'
                    //promoData.memberType = memberType
                    priceData.memberPrice = noRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                    const conditionType = hasRewardType7?.promotionCondition?.[0]?.conditionType ?? 1;
                    const conditionValue = hasRewardType7?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
                    const source = hasRewardType7?.source;
                    priceData.newMemberPrice = parseInt(hasRewardType7?.promotionReward?.[0]?.value1Value20?.[0]?.value_1);
                    memberPrice = priceData.memberPrice
                    promoData.memberPrice = memberPrice
                    promoData.promotionSource = source
                    //priceData.newMemberPrice= priceData.newMemberPrice
                    console.log('multi promo type 2', promotionData?.objectID, "reward_type", rewardType)
                    addPromotionData('multi promo type 2', priceData, offerType = 10, promotionDescription)
                  }
                } else {
                  console.log("no promotions ", promoData.objectID);

                }
              }

            } else {
              // active promotion more than 1 -- multi promotion (2)
              const descRegex =/(?<![a-zA-Z])MP(?![a-zA-Z])/;
              const VKAO_Promotion = activePromotions?.find((item: any) => item?.source == FLYER_PROMOTIONS_SOURCE);
              const regexFilterPromo = activePromotions.find((item: any) => descRegex?.test(item.promotionDescription));
              let showVKAO = false;
              if (regexFilterPromo) {
                const firstPromotion = activePromotions[0]?.promotionReward;
                const secondPromotion = activePromotions[1]?.promotionReward;
                const firstCondition = activePromotions[0]?.promotionCondition;
                const secondCondition = activePromotions[1]?.promotionCondition;
                const rewardType1 = regexFilterPromo?.promotionReward?.[0]?.rewardType;
                const rewardType2 = secondPromotion?.[0]?.rewardType;
                if (firstPromotion?.length == 1 && secondPromotion?.length == 1 && firstCondition?.length == 1 && secondCondition?.length == 1) {
                  if (
                    (
                      // JSON.stringify(firstPromotion?.[0]?.items) ==
                      // JSON.stringify(secondPromotion?.[0]?.items) && (rewardType1 == rewardType2) &&
                      (firstPromotion?.[0]?.membershipLevelText?.includes("N") || firstPromotion?.[0]?.membershipLevelText == '') &&
                      secondPromotion?.[0]?.membershipLevelText?.includes("Y")) ||
                    (firstPromotion?.[0]?.membershipLevelText?.includes("Y") &&
                      (secondPromotion?.[0]?.membershipLevelText?.includes("N") || secondPromotion?.[0]?.membershipLevelText == ''))
                  ) {
                    if (hasNoMinCondition) {
                      showVKAO = true;
                      activePromotions?.forEach((elem: any) => {
                        if (elem?.promotionReward?.[0]?.membershipLevelText.includes("N") || elem?.promotionReward?.[0]?.membershipLevelText == '') {
                          rewardType = elem?.promotionReward?.[0]?.rewardType;
                          memberType = elem?.promotionReward?.[0]?.membershipLevelText;
                          rewardValue = elem?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                          promotionSource = elem?.source;
                          promoData.rewardType = rewardType;
                          // promoData.memberType = memberType;
                          promoData.rewardValue = rewardValue;
                          promoData.promotionSource = promotionSource;
                          res = priceCalculation();
                          priceData.salePrice = res?.salePrice;
                        } else {
                          rewardType = elem?.promotionReward?.[0]?.rewardType;
                          memberType = elem?.promotionReward?.[0]?.membershipLevelText;
                          rewardValue = elem?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                          promoData.rewardType = rewardType;
                          promoData.memberType = memberType;
                          //promoData.rewardValue= rewardValue;
                          res = priceCalculation();
                          priceData.memberPrice = res?.memberPrice;
                        }
                      });
                      // for multi promo discount on sale price for member price
                      const memberPromo = activePromotions?.find((promo: any) => promo?.promotionReward?.[0]?.membershipLevelText?.includes("Y"));
                      const newRewardValue = parseFloat(memberPromo?.promotionReward?.[0]?.value1Value20?.[0]?.value_1);
                      const salePrice = parseFloat(priceData.salePrice);

                      // Only apply logic if both reward types match
                      //   if (rewardType1 === rewardType2) {
                      let newMemberPrice = salePrice;

                      switch (rewardType1) {
                        case 4:
                        case 5:
                          newMemberPrice = newRewardValue / 100;
                          break;
                        case 1: // Fixed discount
                          newMemberPrice = salePrice - newRewardValue / 100;
                          break;

                        case 2: // Percentage discount
                          newMemberPrice =
                            salePrice - (salePrice * newRewardValue) / 100;
                          break;

                        case 3: // Weight-based discount
                          const weight = parseFloat(promotionData?.weight ?? "0");
                          newMemberPrice =
                            salePrice - (newRewardValue / 100) * weight;
                          break;

                        default:
                          break;
                      }

                      priceData.memberPrice = newMemberPrice;
                      console.log("No Min Condition with Multi Promo--", promotionData?.objectID, "reward_type", rewardType, "newMemberPrice", newMemberPrice);
                       addPromotionData("No Min Condition with Multi Promo", priceData, offerType = 6);
                    }

                    //  }
                  }
                }
              }
              if (showVKAO == false && VKAO_Promotion) {
                memberType = VKAO_Promotion?.promotionReward?.[0]?.membershipLevelText;
                rewardType = VKAO_Promotion?.promotionReward?.[0]?.rewardType;
                rewardValue = VKAO_Promotion?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
                promotionSource = VKAO_Promotion?.source
                promoData.memberType = memberType
                promoData.rewardType = rewardType
                promoData.rewardValue = rewardValue
                promoData.promotionSource = promotionSource
                let priceData = priceCalculation();
                console.log('Multi promo only VKAO', promotionData?.objectID, "reward_type", rewardType)
                addPromotionData("Multi promo only VKAO", priceData, offerType = 11)
              }
            }
          } else if (activePromotionLength == 3) {
            const filteredPromo = activePromotions.find((item: any) => item.source == FLYER_PROMOTIONS_SOURCE);
            if (filteredPromo) {
              console.log("filteredPromo", filteredPromo)
              conditionType = filteredPromo?.promotionCondition?.[0]?.conditionType;
              promotionValue = filteredPromo?.promotionCondition?.[0]?.value1Value20?.[0]?.value_1;
              rewardValue = filteredPromo?.promotionReward?.[0]?.value1Value20?.[0]?.value_1;
              rewardTrigger = filteredPromo?.promotionReward?.[0]?.rewardTrigger;
              promotionSource = filteredPromo?.source;
              rewardType = filteredPromo?.promotionReward?.[0]?.rewardType;
              memberType = filteredPromo?.promotionReward?.[0]?.membershipLevelText == ''? 'NNNNNNNNNNNNNNNN' : filteredPromo?.promotionReward?.[0]?.membershipLevelText;
              promoData.conditionType = conditionType;
              promoData.promotionValue = promotionValue;
              promoData.rewardTrigger = rewardTrigger;
              promoData.promotionSource = promotionSource;
              promoData.rewardType = rewardType;
              promoData.rewardValue = rewardValue;
              promoData.memberType = memberType ?? 'NNNNNNNNNNNNNNNN';
              if (hasNoMinCondition) {
                const priceData = priceCalculation();
                console.log('3 Promotions', promotionData?.objectID, "reward_type", rewardType, priceData)
                addPromotionData('3 Promotions', priceData, offerType = 8)
              }
            }


          }
        }
      }
    }
    return  finalData;
  } catch (error) {
    console.log(error);
  }
}

export const generateSectionContent = async (
  section: any,
  doc: any,
  type: string,
  yPosition: number,
  scenePlusIcon?: string | null,
  logo?: any,
  shoppingList?: any,
  filterType?: string,
  searchDropdown?: any,
  storeId?: string

) => {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const bottomMargin = 20;
  const itemHeight = 15;
  if (section) {
    Object.keys(section).forEach((items: any, index: any) => {
      let totalItems = 0;
      if (type == "custom") {
        totalItems = getPdfTotalItems(section[items]);
        yPosition += 4;
        doc.setDrawColor("#939393");
        doc.line(10, yPosition + 36, pageWidth - 10, yPosition + 36);
        doc.setDrawColor(0);
      } else {
        totalItems = getPdfTotalItems(section[items], shoppingList?.products);
      }
      if (yPosition + itemHeight >= pageHeight - bottomMargin) {
        doc.addPage();
        yPosition = 20;
      }
      if (totalItems > 0) {
        yPosition += (shoppingList?.custom?.length > 0) ? 0 : 20; //  Add margin-top before section name
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        if (type == "custom" || items == "Shopped") {
          yPosition += 15; //  Add margin-top before section name
          doc.text(
            decodeHtmlEntities(items),
            10,
            yPosition + (type == "custom" ? -4 : 0)
          );
        }
        doc.setFont("helvetica", "normal");
        doc.setFontSize(14);
        doc.text(
          `${totalItems} item${totalItems > 1 ? "s" : ""}`,
          pageWidth - 10,
          yPosition +
            (filterType != "By Department" && type == "product" && items != "Shopped" ? -19 : -4),
          {
            align: "right",
          }
        );
        yPosition +=
          filterType != "By Department" && type == "product" && items != "Shopped" ? -12 : 5;
        section[items]?.forEach((item: any) => {
          yPosition = generateItemContent(
            doc,
            item,
            type,
            yPosition,
            pageWidth,
            scenePlusIcon,
            shoppingList,
            logo,
            searchDropdown,
            storeId
          );
        });
      }
    });
  }
  return yPosition + 10;
};

export const addCategoryListInfo = async (
  doc: jsPDF,
  sortType: string,
  yPosition: number
) => {
  if (sortType) {
    doc
      .setFont("helvetica", "normal")
      .setFontSize(16)
      .text("Category List Item: ", 10, yPosition);
    doc
      .setFont("helvetica", "bold")
      .text(sortType, 10 + doc.getTextWidth("Category List Item: "), yPosition);
  }
};

export const printPDFs = async (
  products: Product,
  shoppingList: any,
  listName: string,
  filterType: string,
  outputType: string,
  searchDropdown: any,
  storeId?: string
) => {
  const customProduct = { "Custom List": shoppingList?.custom };
  const doc = new jsPDF();
  let yPosition = 10;
  const scenePlusIcon = "";
  const Base64: any = await fetchSvgAsPng();
  const logo = Base64.split(",")[1];

  // Add logo to first page
  // yPosition = addLogo(doc, logo, yPosition);

  if (listName) {
    yPosition = addTitle(doc, listName, yPosition);
  }

  yPosition = await generateSectionContent(
    customProduct,
    doc,
    "custom",
    yPosition,
    "",
    logo,
    "",
    filterType,
    searchDropdown,
    storeId
  );

  // if (outputType == "print" && products && Object.keys(products).length > 0) {
  //   yPosition -= 4;
  //   // addCategoryListInfo(doc, filterType, yPosition);
  // } else {
  //   yPosition += 4;
  // }

  yPosition = await generateSectionContent(
    products,
    doc,
    "product",
    yPosition,
    scenePlusIcon,
    logo,
    shoppingList,
    filterType,
    searchDropdown,
    storeId
  );

  // POST-PROCESSING: Add logo to all pages after content is generated
  const totalPages = (doc as any).internal.getNumberOfPages();
  const logoWidth = 60;
  const logoHeight = 18;
  const logoX = 10;
  const logoY = 10;

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    if (logo) {
      doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);
    }
  }

  if (outputType == "share") {
    const pdfBuffer = Buffer.from(doc.output("arraybuffer"));
    return pdfBuffer;
  } else {
    window.open(URL.createObjectURL(doc.output("blob")));
  }
};

export const getPdfTotalItems = (
  products: ShoppedInterface,
  shoppingList?: ShoppedInterface | null
) => {
  let totalItems = 0;
  if (shoppingList) {
    const articleNumber = new Set(
      products?.map((p: { objectID: string }) => p?.objectID)
    );
    totalItems = shoppingList?.reduce(
      (sum: number, item: { item_id: string; quantity: number }) => {
        return articleNumber.has(item?.item_id) ? sum + item?.quantity : sum;
      },
      0
    );
  } else {
    totalItems = products?.reduce(
      (sum: number, item: { quantity: number }) => sum + item?.quantity,
      0
    );
  }

  return totalItems;
};

export const filterShoppedProducts = (
  products: any[] | Record<string, any>,
  shoppingList: any[],
  is_shopped: number
) => {
  const shoppedItemIds = new Set(
    shoppingList
      .filter((item: { is_shopped: number }) => item?.is_shopped === is_shopped)
      .map((item: { item_id: any }) => item.item_id.toString())
  );
  return products.filter((product: { objectID: any }) =>
    shoppedItemIds.has(product.objectID.toString())
  );
};

export const isValidDateTimeNumber = (number: number) => {
  try {
    const date = new Date(number);
    return !isNaN(date.getTime());
  } catch {
    return false;
  }
};

export const appendStoreIdToItems = (items: Record<string, any>, storeID: string | number) => {
  try {
   const result = items?.map((item: { item_id: string; }) => ({
      ...item,
      item_id: `${item.item_id}_${storeID}`
    }));
    return result
  } catch {
    return [];
  }
};

export const isStockIndicator = (itemStore: (string | number)[], storeId: string | number) => {
  const storeIdStr = String(storeId);
  return Array.isArray(itemStore)
    ? itemStore.some(item => {
        if (typeof item !== 'string') return false;
        const match = item.match(/\/(\d+)$/);
        return match ? match[1] === storeIdStr : false;
      })
    : false;
}

export const showPromotions = (itemStore: (string | number)[], storeId: string | number) => {
  const storeIdStr = String(storeId);
  return Array.isArray(itemStore)
    ? itemStore.some(item => {
        if (typeof item !== 'string') return false;
        const match = item.match(/\/(\d+)$/);
        return match ? match[1].padStart(4, '0') === storeIdStr : false;
      })
    : false;
}

export const showPromotionsAlgolia = (algoliaPromotion: boolean, itemStore: (string | number)[], storeId: string | number) => {
  if(algoliaPromotion){
    return false;
  }
  else if(showPromotions(itemStore as string[] ?? [], storeId)){
    return false;
  }
  else{
    return true;
  }
}

export const checkOfferIdentifier = (offerIdentifier : string) => {
  
  if(offerIdentifier ===
    "No Min Condition" ||
    offerIdentifier ===
    "No Min Condition with Multi Promo" ||
    offerIdentifier ===
    "Multi Reward"||
    offerIdentifier ===
    "multi promo type 1"  ||
    offerIdentifier ===
    "Multi promo only VKAO" ||
    offerIdentifier ===
    "3 Promotions" ||
    offerIdentifier ===
    "multi promo type 2"){
      return true
    }else {
      return false
    }

}